export { SegmentedButtons } from '@/shared/components/segmented-button/SegmentedButtons';
export type {
  SegmentedButton,
  SegmentedButtonsProps
} from '@/shared/components/segmented-button/SegmentedButtons';
export { SegmentedButtonItem } from '@/shared/components/segmented-button/SegmentedButtonItem';
export type {
  SegmentButtonTheme,
  SegmentedButtonItemProps
} from '@/shared/components/segmented-button/SegmentedButtonItem';
